import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import React__default from 'react';
import classNames from 'classnames';
import styles from './ab33e088ca1e8adf9e4535ad397f8162be2c91da463539fbc09bd5528704913f.cfe-internal.js';
import Tooltip from '../Tooltip/cf6cf009c498d67484626c4540161117b545207431106c57103cbe6ecd8eabaf.cfe-internal.js';

var _excluded = ["children", "disabled", "aria-disabled", "className", "tooltipContent", "tooltipPlacement", "isTooltipADescription", "onClick", "onKeyDown"];
var sizePropInIconErrorMessage = 'Warning: The `Icon` prop `size` is invalid when used as a child of `IconButton`.';
var IconButton = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$ariaDisabled = _ref['aria-disabled'],
      ariaDisabled = _ref$ariaDisabled === void 0 ? disabled : _ref$ariaDisabled,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      tooltipContent = _ref.tooltipContent,
      tooltipPlacement = _ref.tooltipPlacement,
      _ref$isTooltipADescri = _ref.isTooltipADescription,
      isTooltipADescription = _ref$isTooltipADescri === void 0 ? false : _ref$isTooltipADescri,
      onClick = _ref.onClick,
      onKeyDown = _ref.onKeyDown,
      rest = _objectWithoutProperties(_ref, _excluded);

  var classes = classNames(className, styles.button, _defineProperty({}, styles.disabled, disabled));

  if (children.props.size) {
    // eslint-disable-next-line no-console
    console.error(sizePropInIconErrorMessage);
  }

  var iconButtonComponent = /*#__PURE__*/React__default.createElement("button", _extends({}, rest, {
    type: "button",
    className: classes,
    "aria-disabled": ariaDisabled,
    ref: ref,
    onClick: disabled ? undefined : onClick,
    onKeyDown: disabled ? undefined : onKeyDown
  }), /*#__PURE__*/React__default.cloneElement(children, {
    size: 'medium',
    'aria-hidden': true
  }));

  if (tooltipContent) {
    return /*#__PURE__*/React__default.createElement(Tooltip, {
      content: tooltipContent,
      placement: tooltipPlacement,
      delayMs: 500,
      "aria-hidden": isTooltipADescription ? undefined : true
    }, iconButtonComponent);
  }

  return iconButtonComponent;
});
var IconButton$1 = IconButton;

export { IconButton$1 as default };
